export default __webpack_public_path__ + "static/home-ac26e534115dc56b6a06659921f909f7.svg";